import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import '@/router/permission' // 权限控制器
import store from './store'
// 页面缓存
import Navigation from 'vue-navigation'
Vue.use(Navigation, { router, store, keyName: 'VNK' })


// import 'element-ui/lib/theme-chalk/select.css';
// import 'element-ui/lib/theme-chalk/option.css';
// import './theme/index.css'
// import { Select,Option } from 'element-ui';
// Vue.use(Select);
// Vue.use(Option);
import Vant from 'vant';
import 'vant/lib/index.css';

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(Vant);

// 播放音频 传入要转的文字
Vue.prototype.$playaudio = audio
Vue.prototype.$http = axios;
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


function audio(text) {
    new Audio( "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=" + text ).play();
}